import { useEffect, useRef, useState } from 'react'
import Header from '../components/Header'
import Menu from '../components/Menu'
import { CiEdit } from 'react-icons/ci'
import { useAllContext } from '../context/AllContext'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { toast } from 'react-toastify'
import Select from 'react-select';
import { useTranslation } from 'react-i18next'

const UserProfile = () => {
    const { t } = useTranslation()
    const limitsUser = JSON.parse(localStorage.getItem('limitsUser'));
    const { getUserDetails, userDetails,
        getCountry, country,
        getCity, city
     } = useAllContext()

    const [inputValue, setInputValue] = useState({
        username: "",
        nickname: "",
        email: "",
        instagram: "",
        twitter: "",
        websiteLink: "",
        school: "",
        teamName: "",
        countryId: "",
        countryName: "",
        cityId: "",
        cityName: ""
    });
    const [editableFields, setEditableFields] = useState({});
    
    const inputHandler = (e) => {
        const {name, value} = e.target;
        setInputValue({
            ...inputValue,
            [name]: value
        })
    }

    const usernameRef = useRef(null);
    const nicknameRef = useRef(null);
    const emailRef = useRef(null);
    const instagramRef = useRef(null);
    const twitterRef = useRef(null);
    const websiteLinkRef = useRef(null);
    const schoolRef = useRef(null);
    const teamNameRef = useRef(null);
    const toggleEditable = (field) => {
    setEditableFields(prev => {
        const updated = {};
            for (const key in prev) {
                updated[key] = false;
            }
            updated[field] = true;
            setTimeout(() => {
                if (field === 'username') usernameRef.current?.focus();
                if (field === 'nickname') nicknameRef.current?.focus();
                if (field === 'email') emailRef.current?.focus();
                if (field === 'instagram') instagramRef.current?.focus();
                if (field === 'twitter') twitterRef.current?.focus();
                if (field === 'websiteLink') websiteLinkRef.current?.focus();
                if (field === 'school') schoolRef.current?.focus();
                if (field === 'teamName') teamNameRef.current?.focus();
            }, 0);
            return updated;
        });
    };
    
    const [errors, setErrors] = useState({});
    const validate = () => {
        let errors = {};
        const emailReg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,})+$/;

        if (!inputValue.email) {
            errors.email = "Email is required"
        } else if (emailReg.test(inputValue.email) === false) {
            errors.email = "Invalid Email";
        }
        return errors;
    };

    const formSubmit = async (e) => {
        e.preventDefault()

        const formErrors = validate();
        setErrors(formErrors);
        
        const apiData = {
            userId: limitsUser._id,
            username: inputValue.username,
            nickname: inputValue.nickname,
            email: userDetails?.email ? "" : inputValue.email,
            country: inputValue.countryName,
            city: inputValue.cityName,
            instagram_link: inputValue.instagram,
            twitter_link: inputValue.twitter,
            website_link: inputValue.websiteLink,
            school: inputValue.school,
            team_name: inputValue.teamName
        }
        
        if (Object.keys(formErrors).length === 0) {
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/GeneralUserProfileUp`, apiData, {
                    headers: {
                        Authorization: `${limitsUser.token}`
                    }
                })
                const data = await response.data

                if(data.status === 1){
                    toast.success(data.message)
                    getUserDetails(limitsUser.token, limitsUser._id)
                } else {
                    toast.error(data.message)
                }

            } catch (error) {
                console.log('Error:', error);
            }
        }
    }

    useEffect(() => {
        if (userDetails) {
            setInputValue({
                username: userDetails.username || "",
                nickname: userDetails.nickname || "",
                email: userDetails.email || "",
                countryName: userDetails.country || "",
                cityName: userDetails.city || "",
                instagram: userDetails.instagram_link || "",
                twitter: userDetails.twitter_link || "",
                websiteLink: userDetails.website_link || "",
                school: userDetails.school || "",
                teamName: userDetails.team_name
            })
        }
    }, [userDetails])

    useEffect(() => {
        getCountry()
        getCity()
        if (limitsUser) {
            getUserDetails(limitsUser.token, limitsUser._id)
        }
    }, [])

    return (
        <>
            <div className='main-content'>
                <Header page={"profile2"} title={"General User Profile"} backpage={'/profile'} />

                <div className='padding2'>
                    <div className='container'>
                        <div className='my-profile mb-5'>
                            {
                                userDetails?.profileImage ? userDetails.profileImage.split('/')[0] === "uploads" ? <img src={`${process.env.REACT_APP_IMAGES_URL}/${userDetails?.profileImage}`} crossOrigin="anonymous" className='img-fluid img1 d-block mx-auto' alt="" />
                                : <img src={`${userDetails?.profileImage}`} className='img-fluid img1 d-block mx-auto' alt="" />
                                : <img src={require('../assets/images/profile.png')} className='img-fluid img1 d-block mx-auto' alt="" />
                            }
                        </div>
                        
                        <div className='profile-form'>
                            <form action="" className='form form1' onSubmit={formSubmit}>
                                <div className='mb-3'>
                                    <div className="comments-input">
                                            <input
                                            type="text"
                                            className="form-control"
                                            value={inputValue.username}
                                            name="username"
                                            onChange={inputHandler}
                                            ref={usernameRef}
                                            placeholder="Username"
                                            disabled={!editableFields.username}
                                        />
                                        <Link className='icon2' onClick={() => toggleEditable('username')}>
                                            <CiEdit />
                                        </Link>
                                    </div>
                                </div>

                                <div className='mb-3'>
                                    <div className="comments-input">
                                        <input
                                            type="text"
                                            name="nickname"
                                            className="form-control"
                                            value={inputValue.nickname}
                                            onChange={inputHandler}
                                            disabled={!editableFields.nickname}
                                            ref={nicknameRef}
                                            placeholder="Nick Name"
                                        />
                                        <Link className='icon2' onClick={() => toggleEditable('nickname')}>
                                            <CiEdit />
                                        </Link>
                                    </div>
                                </div>

                                <div className='mb-3'>
                                    <div className="comments-input">
                                        <input
                                            type="text"
                                            name="email"
                                            className="form-control"
                                            value={inputValue.email}
                                            onChange={inputHandler}
                                            disabled={!editableFields.email}
                                            ref={emailRef}
                                            placeholder="Email"
                                        />
                                        {
                                            !userDetails?.email && <Link className='icon2' onClick={() => toggleEditable('email')}>
                                                <CiEdit />
                                            </Link>
                                        }
                                    </div>
                                    {errors.email && <p className="error-text">{errors.email}</p> }
                                </div>

                                <div className='mb-3 react-select1'>
                                    <div className="comments-input">
                                        {
                                            editableFields.country ? 
                                                <Select
                                                    options={country?.map(items => ({
                                                        value: items._id,
                                                        label: items.name
                                                    }))}
                                                    name="country"
                                                    value={
                                                        inputValue.countryName
                                                            ? {
                                                                value: inputValue.countryId,
                                                                label: country?.find(b => b.name === inputValue.countryName)?.name
                                                            }
                                                            : null
                                                    }
                                                    onChange={(selected) => {
                                                        setInputValue(prev => ({
                                                            ...prev,
                                                            countryId: selected.value,
                                                            countryName: selected.label
                                                        }));
                                                    }}
                                                    placeholder={`${t('Select Country')}`}
                                                />
                                            :   <> 
                                                    <input type="text" className="form-control" defaultValue={inputValue.countryName} disabled placeholder={t('Select Country')}/> 
                                                </>
                                        }
                                        <Link className='icon2' onClick={() => toggleEditable('country')}>
                                            <CiEdit />
                                        </Link>
                                    </div>
                                </div>

                                <div className='mb-3 react-select1'>
                                    <div className="comments-input">
                                        {
                                            editableFields.city ? 
                                                <Select
                                                    options={city?.map(items => ({
                                                        value: items._id,
                                                        label: items.name
                                                    }))}
                                                    name="city"
                                                    value={
                                                        inputValue.cityName
                                                            ? {
                                                                value: inputValue.cityId,
                                                                label: city?.find(b => b.name === inputValue.cityName)?.name
                                                            }
                                                            : null
                                                    }
                                                    onChange={(selected) => {
                                                        setInputValue(prev => ({
                                                            ...prev,
                                                            cityId: selected.value,
                                                            cityName: selected.label
                                                        }));
                                                    }}
                                                    placeholder={`${t('Select City')}`}
                                                />
                                            :   <> 
                                                    <input type="text" className="form-control" defaultValue={inputValue.cityName} disabled placeholder={t('Select City')}/> 
                                                </>
                                        }
                                        <Link className='icon2' onClick={() => toggleEditable('city')}>
                                            <CiEdit />
                                        </Link>
                                    </div>
                                </div>

                                {/* <div className='mb-3'>
                                    <div className="comments-input">
                                        <input type="text" className="form-control" value={inputValue.country} name="country" onChange={inputHandler} placeholder="Country"/>
                                        <CiEdit className='icon2' />
                                    </div>
                                </div>

                                <div className='mb-3'>
                                    <div className="comments-input">
                                        <input type="text" className="form-control" value={inputValue.city} name="city" onChange={inputHandler} placeholder="City"/>
                                        <CiEdit className='icon2' />
                                    </div>
                                </div> */}

                                <div className='mb-3'>
                                    <div className="comments-input">
                                        <input
                                            type="text"
                                            name="instagram"
                                            className="form-control"
                                            value={inputValue.instagram}
                                            onChange={inputHandler}
                                            disabled={!editableFields.instagram}
                                            ref={instagramRef}
                                            placeholder="Instagram"
                                        />
                                        <Link className='icon2' onClick={() => toggleEditable('instagram')}>
                                            <CiEdit />
                                        </Link>
                                    </div>
                                </div>

                                <div className='mb-3'>
                                    <div className="comments-input">
                                        <input
                                            type="text"
                                            name="twitter"
                                            className="form-control"
                                            value={inputValue.twitter}
                                            onChange={inputHandler}
                                            disabled={!editableFields.twitter}
                                            ref={twitterRef}
                                            placeholder="Twitter"
                                        />
                                        <Link className='icon2' onClick={() => toggleEditable('twitter')}>
                                            <CiEdit />
                                        </Link>
                                    </div>
                                </div>

                                <div className='mb-3'>
                                    <div className="comments-input">
                                        <input
                                            type="text"
                                            name="websiteLink"
                                            className="form-control"
                                            value={inputValue.websiteLink}
                                            onChange={inputHandler}
                                            disabled={!editableFields.websiteLink}
                                            ref={websiteLinkRef}
                                            placeholder="Website Link"
                                        />
                                        <Link className='icon2' onClick={() => toggleEditable('websiteLink')}>
                                            <CiEdit />
                                        </Link>
                                    </div>
                                </div>

                                <div className='mb-3'>
                                    <div className="comments-input">
                                        <input
                                            type="text"
                                            name="school"
                                            className="form-control"
                                            value={inputValue.school}
                                            onChange={inputHandler}
                                            disabled={!editableFields.school}
                                            ref={schoolRef}
                                            placeholder="School"
                                        />
                                        <Link className='icon2' onClick={() => toggleEditable('school')}>
                                            <CiEdit />
                                        </Link>
                                    </div>
                                </div>

                                <div className='mb-3'>
                                    <div className="comments-input">
                                        <input
                                            type="text"
                                            name="teamName"
                                            className="form-control"
                                            value={inputValue.teamName}
                                            onChange={inputHandler}
                                            disabled={!editableFields.teamName}
                                            ref={teamNameRef}
                                            placeholder="Team Name"
                                        />
                                        <Link className='icon2' onClick={() => toggleEditable('teamName')}>
                                            <CiEdit />
                                        </Link>
                                    </div>
                                </div>

                                <div className='mt-4'>
                                    <button className='btn btn1 w-100 mt-4'>Update</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <Menu />
            </div>
        </>
    )
}

export default UserProfile
